import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, lifecycle, withHandlers } from 'recompose'

import * as routeActions from 'actions/routeActions'
import * as userActions from 'actions/userActions'

export default compose(
  connect(
    (state) => {
      return {
        pathname: state.router.location.pathname,
      }
    },
    (dispatch) => {
      const actions = {
        ...routeActions,
        ...userActions,
      }

      return {
        actions: bindActionCreators(actions, dispatch),
      }
    },
  ),
  // Handlers
  withHandlers({
    handleLogin: props => (loginFields) => {
      props.actions.loginUser(loginFields)
    },
  }),
)



// WEBPACK FOOTER //
// ./src/containers/core/App/App.enhancer.js